import { PREREGISTRATION_EXPORT_VERIFIED, PREREGISTRATION_FINISH, PREREGISTRATION_STATUS_ENDPOINT, PREREGISTRATION_UPDATE_BOOKS_ENDPOINT } from "@constants/Endpoints";
import { apiCallExportFile, apiCallJson } from "@helpers/ApiCall";

/**
 * @async
 * @function getSchoolPreRegistrationStatus
 * @param {string} schoolId - The unique identifier of the school.
 * @returns {Promise<Object>} A promise that resolves to the pre-registration status of the school.
 */
export async function getSchoolPreRegistrationStatus(schoolId) {
    return await apiCallJson(`${PREREGISTRATION_STATUS_ENDPOINT}?schoolId=${schoolId}`, "GET", null);
}

/**
 * @async
 * @function postPreRegistrationUpdateBooks
 * @param {Object} schoolPreRegistrationUpdateResource - The resource object containing the data to update pre-registration books.
 * @returns {Promise<any>} A promise that resolves with the response of the API call.
 */
export async function postPreRegistrationUpdateBooks(schoolPreRegistrationUpdateResource) {
    return await apiCallJson(PREREGISTRATION_UPDATE_BOOKS_ENDPOINT, "POST", schoolPreRegistrationUpdateResource);
}

/**
 * @async
 * @function putPreRegistrationFinish
 * @param {Object} schoolId - The unique identifier of the school.
 * @returns {Promise<any>} A promise that resolves with the response of the API call.
 */
export async function putPreRegistrationFinish(schoolId) {
    return await apiCallJson(`${PREREGISTRATION_FINISH}?schoolId=${schoolId}`, "PUT", null);
}

/**
 * Downloads the CSV for all schools that have been verified by the Iddink employee.
 * 
 * @async
 * @function downloadVerifiedSchoolsCsv
 * @param {string} filename - The name of the file to be downloaded.
 * @returns {Promise<any>} A promise that resolves with the response of the API call.
 */
export async function downloadVerifiedSchoolsCsv(filename) {
    return await apiCallExportFile(PREREGISTRATION_EXPORT_VERIFIED, "GET", null, filename);
}
